import React from 'react';
import { Box } from '@chakra-ui/react';
import TarjetasResumen from './TarjetasResumen';

const Dashboard: React.FC = () => {
  return (
    <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
      <TarjetasResumen />
    </Box>
  );
};

export default Dashboard;
